import React from 'react';
import { FOLLOW_UP_UI_TEXT } from '../constants/follow-up-intents';

const InformationForm = ({
  showForm,
  formFields,
  formData,
  onInputChange,
  onSubmit,
  onCancel
}) => {
  if (!showForm) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md mx-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          {FOLLOW_UP_UI_TEXT.PROVIDE_INFO_FORM_TITLE}
        </h3>
        
        <div className="space-y-4">
          {formFields.map((field) => (
            <div key={field.name}>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                {field.label}
              </label>
              <input
                type="text"
                value={formData[field.name] || ''}
                onChange={(e) => onInputChange(field.name, e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
                placeholder={`Enter ${field.label.toLowerCase()}`}
                required={field.required}
              />
            </div>
          ))}
        </div>
        
        <div className="flex gap-3 mt-6">
          <button
            onClick={onSubmit}
            className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
          >
            {FOLLOW_UP_UI_TEXT.PROVIDE_INFO_SUBMIT_BUTTON}
          </button>
          <button
            onClick={onCancel}
            className="flex-1 bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300 px-4 py-2 rounded-md hover:bg-gray-400 dark:hover:bg-gray-500 transition-colors"
          >
            {FOLLOW_UP_UI_TEXT.PROVIDE_INFO_CANCEL_BUTTON}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InformationForm;
